import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Vienna day two",
  "description": "",
  "published": "2008-10-19T00:00:00.000Z",
  "redirect_from": ["/blog/vienna-day-two/swizec/54"],
  "categories": "travel",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today my girlfriend held a monster by the boobs and I got to see a very nice looking castle aptly named Schoenbrun and we went to see an art gallery inside Belvedere where there were pretty pictures.`}</p>
    <p>{`And now since I'm a tad knackered from all the walking, here's a bunch of photos you probably won't want to look at since you're all bastards.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      